import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PermissionsService } from '../permissions-service';

@Injectable()
export class PermissionsGuard  {

    constructor(private permissionsService: PermissionsService, private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
        const componentData = route.data;
        return this.permissionsService.isPermitted(componentData.permissions).pipe(map((result) => {
            if (componentData.hasOwnProperty('permissions') && !result) {
                console.warn(`User does not have permission ${componentData.permissions}`);
                this.permissionsService.navigateToForbbidenPage();
                return false;
            }
            return true;
        }));
    }
}
